import ConnectedAccountOriginal from './ConnectedAccountOriginal';

export default function ConnectedAccounts() {
  return <ConnectedAccountOriginal />;
}
